import {getSettings} from './SettingsRepository';

export const getBaseUrl = async (isOkta) => {
    const settings = await getSettings();
    return isOkta
        ? `${settings.forgerockProxyUrl}/memberElectionForgerockProxy`
        : `${settings.memberElectProxyUrl}/memberElectionProxy`;
};

